var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"fade"}},[(_vm.isshow)?_c('v-snackbar',{staticClass:"fixed_",attrs:{"timeout":-1,"value":true,"absolute":"","color":_vm.color,"centered":""}},[_vm._v(" "+_vm._s(_vm.content)+" ")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }